import React from 'react';
import NavBar from "../NavBar";
import Footer from "../Footer";
import "../../Tablet/PackageDetailPage/PackageDetail.css";
import PackageDetails from "../../Common/PackageDetails"

function App() {
  return <X12PackagesDetailPageDesktop {...x12PackagesDetailPageDesktopData} />;
}

export default App;

function X12PackagesDetailPageDesktop(props) {
  const {
    tabletHeader,
    packages,
    rectangle76,
    basic,
    number,
    rsSft,
    place,
    premium,
    luxury,
    clarityDesignLine,
    designDrawings,
    iconParkOutlineBuildingThree,
    structure,
    biDoorOpen,
    doorFrames,
    mdiWindowShutter,
    doorShutters,
    iconParkOutlineDoorHandle,
    doorFittings,
    tablerWindow,
    window,
    icBaselineGridOn,
    flooring,
    footerProps,
    group102Props,
    frame692Props,
    frame692Props2,
    frame692Props3,
    frame1686Props,
    frame16862Props,
    frame16863Props,
  } = props;

  return (
    <div className="pdp-container-center-horizontal">
      <div className="pdp-x12-packages-detail-page-tablet screen">
        <div className="pdp-overlap-group">
          <div className="pdp-frame-1603">
            <NavBar/>
              <PackageDetails />
            {/* <img className="pdp-tablet-header" src={tabletHeader} /> */}
            {/* <h1 className="pdp-title pdp-valign-text-middle">{packages}</h1>
            <img className="pdp-rectangle-76" src={rectangle76} /> */}
            <div style={{marginTop:"20px",width:"100%" }}>
              <Footer/>
            </div>
            {/* <Footer {...footerProps} /> */}
          </div>
          {/* <Group102 place={group102Props.place} group103Props={group102Props.group103Props} />
          <div className="pdp-frame-1695">
            <div className="pdp-basic pdp-valign-text-middle pdp-overpass-extra-bold-white-24px">{basic}</div>
            <div className="pdp-frame-69">
              <div className="pdp-number pdp-valign-text-middle pdp-overpass-extra-bold-white-24px">{number}</div>
              <div className="pdp-rs-sft pdp-valign-text-middle pdp-overpass-normal-white-16px">{rsSft}</div>
            </div>
          </div>
          <div className="pdp-frame-1696">
            <div className="pdp-place pdp-valign-text-middle pdp-overpass-extra-bold-mine-shaft-24px">{place}</div>
            <Frame692 number={frame692Props.number} rsSft={frame692Props.rsSft} />
          </div>
          <div className="pdp-frame-1697">
            <div className="pdp-premium pdp-valign-text-middle pdp-overpass-extra-bold-mine-shaft-24px">{premium}</div>
            <Frame692
              number={frame692Props2.number}
              rsSft={frame692Props2.rsSft}
              className={frame692Props2.className}
            />
          </div>
          <div className="pdp-frame-1698">
            <div className="pdp-luxury pdp-valign-text-middle pdp-overpass-extra-bold-mine-shaft-24px">{luxury}</div>
            <Frame692
              number={frame692Props3.number}
              rsSft={frame692Props3.rsSft}
              className={frame692Props3.className}
            />
          </div>
          <div className="pdp-rectangle-107"></div>
          <div className="pdp-frame-1677">
            <div className="pdp-frame-1675">
              <img className="pdp-claritydesign-line" src={clarityDesignLine} />
              <div className="pdp-design-drawings pdp-valign-text-middle">{designDrawings}</div>
            </div>
            <div className="pdp-frame-1676">
              <img className="pdp-icon-park-outli-ebuilding-three" src={iconParkOutlineBuildingThree} />
              <div className="pdp-structure pdp-valign-text-middle pdp-overpass-extra-bold-black-16px">{structure}</div>
            </div>
            <div className="pdp-frame-1677-1">
              <img className="pdp-bidoor-open" src={biDoorOpen} />
              <div className="pdp-door-frames pdp-valign-text-middle pdp-overpass-extra-bold-black-16px">{doorFrames}</div>
            </div>
            <div className="pdp-frame-1678">
              <img className="pdp-mdiwindow-shutter" src={mdiWindowShutter} />
              <div className="pdp-door-shutters pdp-valign-text-middle pdp-overpass-extra-bold-black-16px">{doorShutters}</div>
            </div>
            <div className="pdp-frame-1679">
              <img className="pdp-icon-park-outlinedoor-handle" src={iconParkOutlineDoorHandle} />
              <div className="pdp-door-fittings pdp-valign-text-middle pdp-overpass-extra-bold-black-16px">{doorFittings}</div>
            </div>
            <div className="pdp-frame-1680">
              <img className="pdp-tablerwindow" src={tablerWindow} />
              <div className="pdp-window pdp-valign-text-middle pdp-overpass-extra-bold-black-16px">{window}</div>
            </div>
            <div className="pdp-frame-1681">
              <img className="pdp-icbaseline-grid-on" src={icBaselineGridOn} />
              <div className="pdp-flooring pdp-valign-text-middle pdp-overpass-extra-bold-black-16px">{flooring}</div>
            </div>
          </div>
          <div className="pdp-frame-1700">
            <Frame1686 text10={frame1686Props.text10} text11={frame1686Props.text11} />
            <Frame1686
              text10={frame16862Props.text10}
              text11={frame16862Props.text11}
              className={frame16862Props.className}
            />
            <Frame1686
              text10={frame16863Props.text10}
              text11={frame16863Props.text11}
              className={frame16863Props.className}
            />
          </div> */}
        </div>
      </div>
    </div>
  );
}


// function Footer(props) {
//   const {
//     layer2,
//     group85,
//     group87,
//     place,
//     mapPin1,
//     phone,
//     mail,
//     text5,
//     text4,
//     contactWebuildCom,
//     quickLinks,
//     aboutUs,
//     projects,
//     gallery,
//     knowledgeTransfer,
//     blogs,
//     faqs,
//   } = props;

//   return (
//     <div className="pdp-footer">
//       <div className="pdp-flex-row-1">
//         <img className="pdp-layer-2" src={layer2} />
//         <img className="pdp-group-85" src={group85} />
//         <img className="pdp-group-87" src={group87} />
//       </div>
//       <div className="pdp-flex-row-2">
//         <div className="pdp-group-32">
//           <div className="pdp-place-1 pdp-valign-text-middle pdp-overpass-extra-bold-white-20px">{place}</div>
//           <div className="pdp-flex-row-3">
//             <div className="pdp-flex-col">
//               <img className="pdp-map-pin-1" src={mapPin1} />
//               <img className="pdp-phone" src={phone} />
//               <img className="pdp-mail" src={mail} />
//             </div>
//             <div className="pdp-flex-col-1">
//               <p className="pdp-text-2 pdp-overpass-normal-white-14px">{text5}</p>
//               <div className="pdp-flex-col-item pdp-valign-text-middle pdp-overpass-normal-white-14px">{text4}</div>
//               <div className="pdp-flex-col-item pdp-valign-text-middle pdp-overpass-normal-white-14px">{contactWebuildCom}</div>
//             </div>
//           </div>
//         </div>
//         <div className="pdp-group-147">
//           <div className="pdp-quick-links pdp-valign-text-middle pdp-overpass-extra-bold-white-20px">{quickLinks}</div>
//           <div className="pdp-flex-row-4">
//             <div className="pdp-about-us pdp-valign-text-middle pdp-overpass-normal-white-16px">{aboutUs}</div>
//             <div className="pdp-projects pdp-valign-text-middle pdp-overpass-normal-white-16px">{projects}</div>
//           </div>
//           <div className="pdp-flex-row">
//             <div className="pdp-gallery pdp-valign-text-middle pdp-overpass-normal-white-16px">{gallery}</div>
//             <div className="pdp-knowledge-transfer pdp-valign-text-middle pdp-overpass-normal-white-16px">{knowledgeTransfer}</div>
//           </div>
//           <div className="pdp-flex-row">
//             <div className="pdp-blogs pdp-valign-text-middle pdp-overpass-normal-white-16px">{blogs}</div>
//             <div className="pdp-fa-qs pdp-valign-text-middle pdp-overpass-normal-white-16px">{faqs}</div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


function Group102(props) {
  const { place, group103Props } = props;

  return (
    <div className="pdp-group-102">
      <Group103>{group103Props.children}</Group103>
      <div className="pdp-place-2">{place}</div>
    </div>
  );
}


function Group103(props) {
  const { children } = props;

  return (
    <div className="pdp-group-103">
      <div className="pdp-overlap-group1">
        <div className="pdp-rectangle-46"></div>
        <div className="pdp-construction">{children}</div>
      </div>
    </div>
  );
}


function Frame692(props) {
  const { number, rsSft, className } = props;

  return (
    <div className={`pdp-frame-69-1 ${className || ""}`}>
      <div className="pdp-number-1 pdp-valign-text-middle pdp-overpass-extra-bold-black-24px2">{number}</div>
      <div className="pdp-rs-sft-1 pdp-valign-text-middle pdp-overpass-normal-mine-shaft-16px">{rsSft}</div>
    </div>
  );
}


function Frame1686(props) {
  const { text10, text11, className } = props;

  return (
    <div className={`pdp-frame-1686 ${className || ""}`}>
      <div className="pdp-text-3 pdp-valign-text-middle pdp-overpass-extra-bold-black-16px">{text10}</div>
      <p className="pdp-text-4 pdp-overpass-normal-scarpa-flow-12px">{text11}</p>
    </div>
  );
}

const footerData = {
    layer2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-148@2x.svg",
    group85: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/group-85-25@2x.svg",
    group87: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60ff87ef3aae7856aca5bd89/img/group-87@2x.svg",
    place: "Contact",
    mapPin1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60eeef698718caded3164f97/img/map-pin--1--4@2x.svg",
    phone: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-151@2x.svg",
    mail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60eebc1043f87cba4b3aaef8/img/mail-2@2x.svg",
    text5: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.",
    text4: "+91 8976535221, +91 8755645342",
    contactWebuildCom: "contact@webuild.com",
    quickLinks: "Quick Links",
    aboutUs: "About Us",
    projects: "Projects",
    gallery: "Gallery",
    knowledgeTransfer: "Knowledge Transfer",
    blogs: "Blogs",
    faqs: "FAQ’s",
};

const group103Data = {
    children: "CONSTRUCTION",
};

const group102Data = {
    place: "INTERIOR",
    group103Props: group103Data,
};

const frame692Data = {
    number: "1600",
    rsSft: "Rs/Sft",
};

const frame6922Data = {
    number: "1600",
    rsSft: "Rs/Sft",
    className: "pdp-frame-69-2",
};

const frame6923Data = {
    number: "1600",
    rsSft: "Rs/Sft",
    className: "pdp-frame-69-3",
};

const frame1686Data = {
    text10: "Design & Drawings",
    text11: <>Floor Plan <br />Front Elevation <br />Structural Drawings:<br />Columns Position <br />Foundation Footing &amp; Columns Details</>,
};

const frame16862Data = {
    text10: "Structure",
    text11: <>Steel: Turbo, Meenakshi, Sunvik or equivalent brand. (TMT Reinforcement Steel to be provided at 2.75 kgs/sft of built up area. All Steel designs are as per Structural engineer‘s drawing)<br />Cement: Ramco, Bharathi, Birla Shakti, ACC or equivalent Brand(53 Grade for Concrete works &amp; 43 Grade for other works)<br />RMC: ACC or Ultratech <br />PCC Works of M15 Grade 1 : 2 :4 <br />RCC Works of M 25 Grade for Column Footing, Plinth Beams, Columns and Roof Slabs. Thickness of roof slab shall be 5” thick<br />RCC Works of M 20 Grade for Lintel, Canopy Projections, Staircase <br />Column Sizes will be of 8”x18” min <br />Soil testing (SBC of 180kN/m2 at 5’ depth from EGL)<br />Water Proofing: Dr. Fixit<br />Roof to Roof Height be 10’0”<br />6” Blocks for Exterior &amp; 4” for Interior<br />Window Area will 125sft for Every 1000sft of Bulit Up Area</>,
    className: "pdp-frame-168",
};

const frame16863Data = {
    text10: "Structure",
    text11: <>Steel: Turbo, Meenakshi, Sunvik or equivalent brand. (TMT Reinforcement Steel to be provided at 2.75 kgs/sft of built up area. All Steel designs are as per Structural engineer‘s drawing)<br />Cement: Ramco, Bharathi, Birla Shakti, ACC or equivalent Brand(53 Grade for Concrete works &amp; 43 Grade for other works)<br />RMC: ACC or Ultratech <br />PCC Works of M15 Grade 1 : 2 :4 <br />RCC Works of M 25 Grade for Column Footing, Plinth Beams, Columns and Roof Slabs. Thickness of roof slab shall be 5” thick<br />RCC Works of M 20 Grade for Lintel, Canopy Projections, Staircase <br />Column Sizes will be of 8”x18” min <br />Soil testing (SBC of 180kN/m2 at 5’ depth from EGL)<br />Water Proofing: Dr. Fixit<br />Roof to Roof Height be 10’0”<br />6” Blocks for Exterior &amp; 4” for Interior<br />Window Area will 125sft for Every 1000sft of Bulit Up Area</>,
    className: "pdp-frame-168",
};

const x12PackagesDetailPageDesktopData = {
    tabletHeader: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60eebc1043f87cba4b3aaef8/img/frame-144@1x.svg",
    packages: "Packages",
    rectangle76: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60ff87ef3aae7856aca5bd89/img/rectangle-76@1x.png",
    basic: "Basic",
    number: "1600",
    rsSft: "Rs/Sft",
    place: "Standard",
    premium: "Premium",
    luxury: "Luxury",
    clarityDesignLine: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60ff87ef3aae7856aca5bd89/img/clarity-design-line@2x.svg",
    designDrawings: "Design & Drawings",
    iconParkOutlineBuildingThree: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60ff87ef3aae7856aca5bd89/img/icon-park-outline-building-three@2x.svg",
    structure: "Structure",
    biDoorOpen: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60ff87ef3aae7856aca5bd89/img/bi-door-open-1@2x.svg",
    doorFrames: "Door Frames",
    mdiWindowShutter: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60ff87ef3aae7856aca5bd89/img/mdi-window-shutter@2x.svg",
    doorShutters: "Door Shutters",
    iconParkOutlineDoorHandle: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60ff87ef3aae7856aca5bd89/img/icon-park-outline-door-handle@2x.svg",
    doorFittings: "Door Fittings",
    tablerWindow: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60ff87ef3aae7856aca5bd89/img/tabler-window@2x.svg",
    window: "Window",
    icBaselineGridOn: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60ff87ef3aae7856aca5bd89/img/ic-baseline-grid-on@2x.svg",
    flooring: "Flooring",
    footerProps: footerData,
    group102Props: group102Data,
    frame692Props: frame692Data,
    frame692Props2: frame6922Data,
    frame692Props3: frame6923Data,
    frame1686Props: frame1686Data,
    frame16862Props: frame16862Data,
    frame16863Props: frame16863Data,
};

